/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */

// Primary & Secondary colors
export const BLUE = "#0066BF";
export const YELLOW = "#FFE600";

// Font
export const FONT_DARKGREY = "#2C3236";
export const FONT_MIDGREY = "#5D676C";
export const FONT_LIGHTGREY = "#A1AAAF";

// Greys (based on first 2 letters of hex code)
export const GREY_CC = "#CCCCCC";
export const GREY_DE = "#DEDEE0"; // borders
export const GREY_F1 = "#F1F1F1";
export const GREY_F9 = "#F9F9F9";
